import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

import { catchError, first, tap } from 'rxjs/operators';
import { ApiService } from '../services/api.service';
import { of } from 'rxjs';
import { Poi } from '../core/poi/poi.model';
import { PoiActionService } from '../core/poi/poi.action';

@Injectable()
export class SinglePoiResolver implements Resolve<Poi> {

  constructor(private service: ApiService,
              private poiAction: PoiActionService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const actualRoute = state.url;
    const idFromUrl = parseInt(actualRoute.split('/').pop(), 10);
    return this.service.poiDetail(idFromUrl).pipe(
      first(),
      tap((data: any) => {
        this.poiAction.setPoiCurrent(Poi.from(data));
      }),
      catchError((err) => {
        console.error('Non è stato possibile recuperare il singolo POI');
        return of(err);
      })
    );
  }
}
